import { Database } from "./persistence"

/**
 * Checks if the stored version matches the current version.
 * If not, clears localStorage and IndexedDB.
 * @param currentVersion - The current application version
 * @param versionKey - The key to store the version in localStorage
 * @returns boolean - True if versions match, false if cleared
 */
export function checkAndUpdateVersion(
    currentVersion: string,
    versionKey: string = 'app_version'
): boolean {
    try {
        // Get stored version from localStorage
        const storedVersion = localStorage.getItem(versionKey);

        // If version doesn't match
        if (storedVersion !== currentVersion) {
            console.log(`Version mismatch: stored=${storedVersion}, current=${currentVersion}. Clearing data...`);
            try {
                // Clear localStorage
                const hasConsent = localStorage.getItem('cookieConsent');
                const rememberedAccount = localStorage.getItem('rememberedAccount');
                localStorage.clear();

                // Clear IndexedDB (using idb-keyval library)
                Database.destroyDatabase()

                // Store new version
                localStorage.setItem(versionKey, currentVersion);
                if (hasConsent === 'true') {
                    localStorage.setItem('cookieConsent', 'true');
                }

                if (rememberedAccount) {
                    localStorage.setItem('rememberedAccount', rememberedAccount);
                }

            } catch (error) {
                console.error('Error clearing data:', error);
                // If there's an error, we can choose to either throw or just log it
                // throw new Error('Failed to clear data: ' + error.message);
            }



            return false;
        }

        return true;
    } catch (error) {
        console.error('Error during version check:', error);
        return false;
    }
}